import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { api } from "../services/api";
import PageHeader from "./ui/PageHeader";
import StatusBadge from "./ui/StatusBadge";
import LoadingState from "./ui/LoadingState";
import AlertBanner from "./ui/AlertBanner";

const WalletManagement = () => {
  const [wallets, setWallets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.getWallets().then(setWallets).catch((err) => setError(err.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingState message="Loading wallets..." />;
  if (error) return <AlertBanner type="danger" message={error} />;

  return (
    <div>
      <PageHeader title="Wallet Management" subtitle="Billr wallet — UPI top-ups, bill pay & cashback (INR)" />

      <Row className="g-3">
        {wallets.map((w) => (
          <Col md={6} lg={4} key={w.walletId}>
            <div className="wallet-card">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h6 className="mb-1">{w.customerName}</h6>
                  <span className="text-muted small">{w.phone}</span>
                </div>
                <StatusBadge status={w.statusKey} label={w.status} />
              </div>
              <div className="wallet-balance mb-3">{w.balance}</div>
              <p className="small fw-semibold text-muted mb-2">Recent activity</p>
              {w.recentTransactions.length === 0 ? (
                <p className="small text-muted mb-0">No activity</p>
              ) : (
                <ul className="list-unstyled mb-0 small">
                  {w.recentTransactions.map((t, i) => (
                    <li key={i} className="mb-2 pb-2 border-bottom">
                      <StatusBadge status={t.txn_type === "credit" ? "success" : "secondary"} label={t.txn_type} />
                      <span className="ms-2">₹{parseFloat(t.amount).toFixed(2)}</span>
                      <div className="text-muted">{t.description}</div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default WalletManagement;
